<template>
  <div class="divBox">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <div class="container">
          <el-form size="small" inline label-width="100px">
            <el-form-item label="关键字：" class="width100" style="display: inline-block;">
              <el-input
                v-model="tableFrom.keyword"
                @keyup.enter.native="getList(1)"
                placeholder="请输入订单号/sku/收货人/联系方式"
                class="selWidth"
                size="small"
              >
                <el-button slot="append" icon="el-icon-search" size="small" class="el-button-solt" @click="getList(1)"/>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <el-table
        v-loading="listLoading"
        :data="tableData.data"
        style="width: 100%"
        size="small"
      >
        <el-table-column
          label="ID"
          prop="recovery_category_id"
          min-width="60"/>
        <el-table-column
          label="品类"
          prop="sku"
          min-width="260">
          <template slot-scope="scope">
              <span>
                <span v-if="scope.row.cate_name">
                  {{scope.row.cate_name}}/
                </span>
                {{scope.row.sku}}
              </span>
          </template>
        </el-table-column>

        <el-table-column
          label="出库价格"
          prop="price"
          min-width="100">
          <template slot-scope="scope">
              {{scope.row.price || '0.00'}}
          </template>
        </el-table-column>
        <el-table-column
          label="总库存"
          min-width="200"
          prop="count_warehous">
        </el-table-column>
        <el-table-column
          label="甄美库存数量"
          min-width="200"
          prop="zhenmei_count_yes_warehous"/>
        <el-table-column
          label="可出库数量"
          prop="count_yes_warehous"
          min-width="100"/>
        <el-table-column
          label="寄存数量"
          prop="count_damage"
          min-width="80"/>

        <el-table-column label="操作" min-width="180" fixed="right">
          <template slot-scope="scope">
            <div style="display: flex;flex-wrap: wrap">
              <el-button type="text" size="small" @click="addWarehousFn(scope.row)">增加库存</el-button>
              <el-button type="text" size="small" @click="renewWarehous(scope.row)">更新库存</el-button>
              <el-button type="text" size="small" @click="onDetail(scope.row)">立即出库</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
<!--      <div class="block">-->
<!--        <el-pagination-->
<!--          :page-sizes="[20, 40, 60, 80]"-->
<!--          :page-size="tableFrom.limit"-->
<!--          :current-page="tableFrom.page"-->
<!--          layout="total, sizes, prev, pager, next, jumper"-->
<!--          :total="tableData.total"-->
<!--          @size-change="handleSizeChange"-->
<!--          @current-change="pageChange"-->
<!--        />-->
<!--      </div>-->
    </el-card>
    <el-dialog v-if="dialogVisible" title='详情' :visible.sync="dialogVisible" width="1000px" top="50px">
      <div class=" boxDetial" style="display: flex;flex-direction: column;align-items: center;height: 800px;overflow-y: scroll;position:relative;">
       <div style="width: 800px;box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);padding: 20px">
         <div class="detail_title" style="font-size: 16px;font-weight: bold">
           商品信息
         </div>
         <div class="" style="margin-top: 20px">
           出库商品：<span v-if="detailData.cate_name">{{detailData.cate_name}}/</span>{{detailData.sku}}
         </div>
         <div class="" style="margin-top: 20px;display: flex;align-items: center">
           出库数量：
           <span style="color: red;font-size: 16px;margin-right: 20px">当前库存数为{{detailData.count_yes_warehous}}</span>
           <el-input-number :min="1"  :max="detailData.count_yes_warehous"
                            v-model="detailData.outbound_num"  :step="1" size="medium"></el-input-number>
         </div>
         <div class="" style="margin-top: 20px">
           结算价格：<el-input v-model="detailData.price" placeholder="请输入结算价格" style="width: 300px"></el-input>
         </div>
       </div>
        <div style="width: 800px;box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);padding: 20px;margin-top: 20px">
          <div class="detail_title" style="font-size: 16px;font-weight: bold;display: flex;align-items: center;justify-content: space-between">
            批号
            <span style="color: #ED4655;cursor: pointer" @click="addFn">+ 添加批号</span>
          </div>
          <div class="" style="margin-top: 20px;display: flex;align-items: center" v-for="(item,index) in detailData.batch_number_list">
            录入批号：
            <el-input v-model="item.batch_number" placeholder="请输入商品批号" style="width: 300px;margin-right: 20px"></el-input>
            <el-input-number v-model="item.num" :min="0" :max="maxFn(item,index)" @change="changeFn($event,index)" label="描述文字"></el-input-number>
          </div>
        </div>
        <div class="btnss"><el-button type="primary"  @click="outFn">立即出库</el-button></div>
      </div>
    </el-dialog>



    <el-dialog v-if="addStockShow" title='增加库存' :visible.sync="addStockShow" width="1000px" top="50px">
      <div class=" boxDetial" style="display: flex;flex-direction: column;align-items: center;height: 800px;overflow-y: scroll;position:relative;">
        <div style="width: 800px;box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);padding: 20px">
          <div class="detail_title" style="font-size: 16px;font-weight: bold">
            商品信息
          </div>
          <div class="" style="margin-top: 20px">
            商品：<span v-if="addStockData.cate_name">{{addStockData.cate_name}}/</span>{{addStockData.sku}}
          </div>
          <div class="" style="margin-top: 20px;display: flex;align-items: center">
            入库数量：
            <span style="color: red;font-size: 16px;margin-right: 20px">当前库存数为{{addStockData.count_yes_warehous}}</span>
            <el-input-number :min="1" v-model="addStockData.wareHous_num" size="medium"></el-input-number>
          </div>
          <div class="" style="margin-top: 20px;display: flex;align-items: center">
            入库批号：
            <el-input v-model="addStockData.batch_number" placeholder="请输入入库批号" style="width: 300px"></el-input>
          </div>
          <div class="" style="margin-top: 20px;display: flex;align-items: center">
            入库金额：
            <el-input v-model="addStockData.wareHous_price" placeholder="请输入入库金额" style="width: 300px"></el-input>
          </div>

          <div class="" style="margin-top: 20px;display: flex;align-items: center">
            备注：
            <el-input type="textarea" v-model="addStockData.wareHous_remark" placeholder="备注" style="width: 300px"></el-input>
          </div>
        </div>
        <div class="btnss"><el-button type="primary"  @click="addStock">立即增加</el-button></div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  // +----------------------------------------------------------------------
  // | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
  // +----------------------------------------------------------------------
  // | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
  // +----------------------------------------------------------------------
  // | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
  // +----------------------------------------------------------------------
  // | Author: CRMEB Team <admin@crmeb.com>
  // +----------------------------------------------------------------------
  import {roterPre} from '@/settings'
  import {fromList} from "@/libs/constants";
  import {
    productOutbound,
    recoveryOrderCancelExpressApi,
    recoveryOrderCardListApi,
    recoveryOrderChartListApi,
    recoveryOrderDeleteApi,
    recoveryOrderHandleReturnApi,
    recoveryOrderHandleWornApi,
    recoveryOrderRenewWarehousExpressApi,
    warehousList,
    warehousAddNum
  } from "@/api/recovery";
  import cardsData from "@/components/cards";
  import {appraisalEntityOrderCancelExpressApi, appraisalOrderEntityAuditApi} from "@/api/appraisal";
  import {batchChangeGroupApi} from "@/api/user";
  import orderWornHandle from "@/views/recovery/order/orderWornHandle";
  import orderReturnHandle from "@/views/recovery/order/orderReturnHandle";
  export default {
    name: 'appraisalEntityOrder',
    components: {cardsData,orderWornHandle,orderReturnHandle},
    computed:{
      maxFn(){
        return function (item,index) {
          let nums = 0
          this.detailData.batch_number_list.map((item1,index1)=>{
            nums+= item1.num
          })
          return (this.detailData.outbound_num - nums) + item.num
        }
      },
      wornStatusFn(){
        return function (status) {
          switch (status) {
            case 0 :
              return '下单成功'
              break;
            case 1 :
              return '已接单'
              break;
            case 9 :
              return '已取消'
              break;
            case 10 :
              return '已取件'
              break;
            case 13 :
              return '已签收'
              break;
          }
        }
      }
    },
    data() {
      return {
        props: {checkStrictly: true, emitPath: false},
        moren: require("@/assets/images/f.png"),
        colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
        listLoading: true,
        tableData: {
          data: [],
          total: 0
        },
        addStockShow:false, // 控制增加库存弹框
        addStockData:{
          wareHous_price:'',
          wareHous_num:1,
          batch_number:'',
          recovery_category_id:'',
          sku:'',
          wareHous_remark:'',
        },  // 增加库存的对象
        roterPre: roterPre,
        tableFrom: {
          page: 1,
          limit: 20,
        },
        orderChartType: {},
        detailData:{
          outbound_num:1,
          batch_number_list:[],
          recovery_category_id:0,
          sku:'',
          count_yes_warehous:0,
          price:''
        },
        fromList: fromList,
        cardLists: [],
        timeVal: [],
        warehousTimeVal: [],
        dialogVisible: false,
        dialogVisibleStatus: false,
        loading: false,
        formData: {},
        ruleForm: {},
        appraisal_order_id: '',
        recoveryCateList: [],
        formStatusData: [],
        status: '',
        statusList: [],
        recovery_price_total: 0,
        recovery_num_total: 0,
        chkName: '',
        checkedIds: [], // 订单当前页选中的数据
        noChecked: [], // 订单全选状态下当前页不选中的数据
        checkedPage: [],
        allCheck: false,
        cancel_time: null,
        recoveryOrderIdList: {
          recovery_order_id_list: []
        },
        visibleWornHandle:false,
        visibleReturnHandle:false,
        recovery_order_id: 0,
        old_flag: 0,
        renewData: {
          recovery_category_id:0,
          sku:'',
        },

      }
    },
    mounted() {
      this.getList(1)
      this.headerList()
      this.getCardList()
      this.checkedIds = []
    },
    methods: {
      // 账户详情
      onWornHandle(id) {
        this.recovery_order_id = id
        this.visibleWornHandle = true
      },
      onReturnHandle(id)
      {
        this.recovery_order_id = id
        this.visibleReturnHandle = true
      },
      returnClose() {
        this.visibleWornHandle = false
        this.visibleReturnHandle = false
        this.getList(1)
      },
      sendSuccess(){
        this.visibleWornHandle = false
        this.visibleReturnHandle = false
        this.getList(1)
      },
      /**
       * 增加库存
       * */
      async addStock(){
        if(!this.addStockData.wareHous_price){
          this.$message({
            message:'请输入入库金额',
            type:'error'
          })
          return
        }
        let params = this.addStockData
        let data = await warehousAddNum(params)
        this.addStockShow = false
        this.getList()
      },

      // 立即出库
      async outFn(){
        if(!this.detailData.price){
            this.$message({
              message:'请填写结算价格',
              type:'error'
            })
            return
        }
        if(this.detailData.batch_number_list.some((v,i)=>{return !v.batch_number})){
            this.$message({
              message:'请坚持批号是否填写完整',
              type:'error'
            })
          return
        }


        try {
          let params = this.detailData
          let data = await productOutbound(params)
          if(data.status == 200){
            this.$message({
              message:data.message,
              type:'success'
            })

            this.dialogVisible = false
            this.getList()
          }else{
            this.$message({
              message:data.message,
              type:'error'
            })
          }
        } catch (e) {
          this.$message({
            message:e.message,
            type:'error'
          })
        }

      },

      addFn(){
        let nums = 0
        this.detailData.batch_number_list.map((v,i)=>{
          nums+= v.num
        })
        if(nums>=this.detailData.outbound_num){
          return
        }
        this.detailData.batch_number_list.push({
          batch_number:'',
          num:1
        })
        this.$forceUpdate()
      },
      changeFn(e,index){
        console.log(e)
        if(e==0){
          this.$nextTick(()=>{
            this.detailData.batch_number_list.splice(index,1)
          })
        }
      },
      // 详情
      onDetail(item) {
        this.detailData.recovery_category_id = item.recovery_category_id
        this.detailData.sku = item.sku
        this.detailData.outbound_num = 1
        this.detailData.batch_number_list = []
        this.detailData.count_yes_warehous = item.count_yes_warehous
        this.detailData.price = item.price
        this.dialogVisible = true;
        console.log(this.detailData)
        // this.isExamine = false;
        // recoveryOrderDetailApi(id).then((res) => {
        //   this.formData = res.data
        // }).catch(({message}) => {
        //   this.$message.error(message)
        // })
      },
      headerList() {
        recoveryOrderChartListApi()
          .then((res) => {
            this.orderChartType = res.data;
          })
          .catch((res) => {
            this.$message.error(res.message);
          });
      },
      // 增加库存
      addWarehousFn(row){
        // row.batch_number_list=[]
        // row.num = 1
        this.addStockData.wareHous_num = 1
        this.addStockData.wareHous_remark = ''
        this.addStockData.batch_number = ''
        this.addStockData.recovery_category_id = row.recovery_category_id
        this.addStockData.sku = row.sku
        this.addStockData.wareHous_price = row.price
        this.addStockShow = true

        this.$forceUpdate()
      },
      renewWarehous(item)
      {
        this.renewData.recovery_category_id = item.recovery_category_id
        this.renewData.sku = item.sku
        this.$modalSure('确定要更新库存吗？').then(() => {
          recoveryOrderRenewWarehousExpressApi(this.renewData).then(({message}) => {
            this.$message.success(message)
            this.getList('')
          }).catch(({message}) => {
            this.$message.error(message)
          })
        })

      },
      // 列表
      getList(num) {
        this.listLoading = true
        this.tableFrom.page = num ? num : this.tableFrom.page
        console.log(this.tableFrom)
        warehousList(this.tableFrom).then(res => {
          this.tableData.data = res.data
          this.checkedIds = []
          this.listLoading = false
        }).catch(res => {
          this.listLoading = false
          this.$message.error(res.message)
        })
      },
      pageChange(page) {
        this.tableFrom.page = page
        this.getList('')
      },
      handleSizeChange(val) {
        this.tableFrom.limit = val
        this.getList('')
      },
      // 删除
      handleDelete(id, idx) {
        this.$modalSure().then(() => {
          recoveryOrderDeleteApi(id).then(({message}) => {
            this.$message.success(message)
            this.getList()
          }).catch(({message}) => {
            this.$message.error(message)
          })
        })
      },
      handleReturnHandle(id, idx) {
        this.$modalSure().then(() => {
          recoveryOrderHandleReturnApi(id).then(({message}) => {
            this.$message.success(message)
            this.getList()
          }).catch(({message}) => {
            this.$message.error(message)
          })
        })
      },
      //取消异常订单
      handleWornHandle(id, idx) {
        this.$modalSure().then(() => {
          recoveryOrderHandleWornApi(id).then(({message}) => {
            this.$message.success(message)
            this.getList()
          }).catch(({message}) => {
            this.$message.error(message)
          })
        })
      },
      //取消寄件
      onCancelExpress(id, idx) {
        this.$modalSure('确定取消寄件吗？').then(() => {
          recoveryOrderCancelExpressApi(id).then(({message}) => {
            this.$message.success(message)
            this.getList('')
          }).catch(({message}) => {
            this.$message.error(message)
          })
        })
      },
      getCardList() {
        recoveryOrderCardListApi(this.tableFrom)
          .then((res) => {
            this.cardLists = res.data;
          })
          .catch((res) => {
            this.$message.error(res.message);
          });
      },
    }
  }
</script>

<style scoped lang="scss">
  /deep/.boxDetial .el-form-item {
    margin-bottom: 0px;
  }
  /deep/.el-form-item{
    /*margin-bottom: 0!important;*/
  }
  .box-container {
    overflow: hidden;
  }

  .box-container .list {
    float: left;
    line-height: 40px;
  }

  .box-container .sp {
    width: 50%;
  }

  .box-container .sp3 {
    width: 33.3333%;
  }

  .box-container .sp100 {
    width: 100%;
  }
  .decla_row{
    width: 100%;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
    margin:40px 0 0;
    padding: 20px 20px 0;
    box-sizing: border-box;
  }
  .batch_num{
    color: red;
    font-size: 16px;
  }
  .decla_title{
    font-size: 16px;
    font-weight: bold;
  }
  .box-container .list .name {
    display: inline-block;
    width: 150px;
    text-align: right;
    color: #606266;
  }
  .skuList{
    border-bottom: 2px solid #f4f4f5;
    margin-bottom: 10px;
  }
  .blodClass{
    font-size:14px;
    color: red;
    font-weight: bold;
  }
  .box-container .list.image {
    margin-bottom: 40px;
  }

  .box-container .list.image img {
    position: relative;
    top: 40px;
  }

  .btnss{
    position: absolute;
    bottom: 0;
    right: 40px;

  }
  /deep/ .el-form-item__content .el-rate {
    position: relative;
    top: 8px;
  }
  .cate_name{
    width: 200px;
  }
  .sku-tb {
    border: 1px solid black;
    border-collapse: collapse;
    margin-bottom: 20px;
    width: 750px;
    tr {
      th, td {
        border: 1px solid black;
        text-align: center;

        .sku-name {
          margin: 0 auto;
          width: 100px;
          /*height: 30px;*/
          /*overflow: hidden;*/
          line-height: 24px;
          text-overflow: ellipsis;
          /*word-break: keep-all;*/
        }
      }
    }
  }
</style>
